// The /create studio's main flow (pages/create.tsx, components/studio:
// VoicePicker, WhoSings, SongPicker, SongSources, useCreateCover).
// See messages/README.md for how to add strings.
export const studio = {
  en: {
    // pages/create.tsx
    "studio.title.none": "Make a cover",
    "studio.title.one": "Make {name} sing",
    "studio.title.many": "Make them sing",
    "studio.section.voice": "Voice",
    "studio.section.whoSings": "Who sings",
    "studio.section.count": "{n} of {max}",
    "studio.section.audio": "Audio",
    "studio.pickVoice": "Pick a voice",
    "studio.pickVoiceNote": "Any of 100,000+ voices, or your own",
    "studio.addVoice": "Add a voice",
    "studio.whoSingsWhen": "Who sings when",
    "studio.sound": "Sound",
    "studio.video": "Video",
    "studio.video.off": "Race your voices in a Marble Run",
    "studio.video.on": "Marble Run · 1 coin",
    "studio.video.add": "Add Marble Run · 1 coin",
    "studio.coins.unlimited": "Unlimited coins on Power",
    "studio.coins.one": "{count} coin left",
    "studio.coins.other": "{count} coins left",
    "studio.done": "Done",
    "studio.remove": "Remove",
    "studio.cta.pickVoice": "Pick a voice first",
    "studio.cta.addAudio": "Add audio",
    "studio.cta.create": "Create cover",
    "studio.auth.video": "Sign up to make a video",
    "studio.auth.audio": "Sign up to use your audio",
    "studio.auth.save": "Save your cover",
    "studio.upgrade.marbleRun": "Upgrade to Creator to make Marble Run videos",
    "studio.creatorReady": "You're on Creator. Pick your Marble Run.",
    "studio.maxVoices": "You can select a maximum of {max} voices.",
    "studio.alreadyIn": "{name} is already in this cover.",

    // VoicePicker
    "studio.voices.search": "Search voices",
    "studio.voices.clear": "Clear search",
    "studio.voices.trending": "Trending",
    "studio.voices.recent": "Recently used",
    "studio.voices.mine": "My voices",
    "studio.voices.music": "Music",
    "studio.voices.cartoon": "Cartoon",
    "studio.voices.gaming": "Gaming",
    "studio.voices.anime": "Anime",
    "studio.voices.publicFigure": "Public figure",
    "studio.voices.oftenWith": "Often with {name}",
    "studio.voices.pairedWith": "Often paired with {name}",
    "studio.voices.add": "Add {name}",
    "studio.voices.change": "Change {name}",
    "studio.voices.removeName": "Remove {name}",
    "studio.voices.upTo": "Up to {max}",
    "studio.voices.makeDuet": "Make it a duet",
    "studio.voices.uses": "{n} uses",
    "studio.voices.noMatch": "No voices match that search.",
    "studio.voices.noMine": "You have no trained voices yet.",
    "studio.voices.noPairs":
      "No duets with this voice yet this week. Try Trending.",
    "studio.empty": "Nothing here yet.",
    "studio.change": "Change",

    // WhoSings
    "studio.who.auto": "Auto pick",
    "studio.who.manual": "Choose myself",
    "studio.who.chose.one": "You chose · {n} part",
    "studio.who.chose.other": "You chose · {n} parts",
    "studio.who.autoExplain":
      "The voices take turns wherever the singing changes.",
    "studio.who.autoCanChoose":
      "Want a say? Choose myself lets you pick who sings each part.",
    "studio.who.autoNeedsFile":
      "Choosing yourself needs an upload, a recording or a library song.",
    "studio.who.loading": "Loading the song…",
    "studio.who.failed":
      "We couldn't play this song here, so Jammable will decide.",
    "studio.who.pause": "Pause",
    "studio.who.playSong": "Play the song",
    "studio.who.partLabel": "{name}, {start} to {end}",
    "studio.who.moveSwap": "Move where the voices swap",
    "studio.who.part": "Part {n}",
    "studio.who.play": "Play",
    "studio.who.split": "Split",
    "studio.who.takeOver": "Who takes this part over?",
    "studio.who.before": "The part before",
    "studio.who.after": "The part after",
    "studio.who.sungBy": "Sung by",
    "studio.who.hint":
      "Tap a part to hear it and choose who sings it. Drag the white handles to move where the voices swap.",
    "studio.who.tooShort": "Each part needs at least {secs} seconds.",

    // SongPicker
    "studio.song.upload": "Upload",
    "studio.song.library": "Library",
    "studio.song.tts": "Type words",
    "studio.song.generate": "AI song",
    "studio.song.mic": "Record",
    "studio.song.sources": "Where the song comes from",
    "studio.song.rights": "Only upload audio you have the rights to use.",
    "studio.song.search": "Search songs",
    "studio.song.searchUploads": "Search your uploads",
    "studio.song.searchLibrary": "Search the song library",
    "studio.song.popular": "Popular",
    "studio.song.yourUploads": "Your uploads",
    "studio.song.noMatch": "No songs match that search.",
    "studio.song.noUploads": "You haven't uploaded anything yet.",
    "studio.song.picked": "Picked",
    "studio.source.generate": "AI Generated",
    "studio.source.upload": "Uploaded",
    "studio.source.library": "From Library",
    "studio.source.mic": "Recorded",
    "studio.source.tts": "Text to Speech",

    // SongSources: Type words
    "studio.tts.what": "What should they say?",
    "studio.tts.placeholder": "Type what they should say...",
    "studio.tts.baseVoice": "BASE VOICE",
    "studio.tts.accent": "ACCENT",
    "studio.tts.delivery": "DELIVERY",
    "studio.tts.use": "Use these words",
    "studio.tts.empty": "Please enter some text.",
    "studio.tts.tooLong": "Text exceeds the maximum limit of {max} characters.",
    "studio.tts.gender.female": "Female",
    "studio.tts.gender.male": "Male",
    "studio.tts.accent.US": "American",
    "studio.tts.accent.GB": "British",
    "studio.tts.accent.FR": "French",
    "studio.tts.accent.DE": "German",
    "studio.tts.accent.ES": "Spanish",
    "studio.tts.accent.IT": "Italian",
    "studio.tts.accent.KR": "Korean",
    "studio.tts.accent.AU": "Australian",
    "studio.tts.accent.JP": "Japanese",
    "studio.tts.expr.default": "Default",
    "studio.tts.expr.whispered": "Whispered",
    "studio.tts.expr.happy": "Happy",
    "studio.tts.expr.sad": "Sad",
    "studio.tts.expr.angry": "Angry",
    "studio.tts.expr.shouting": "Shouting",
    "studio.tts.expr.terrified": "Terrified",

    // SongSources: AI song
    "studio.ai.style": "PICK A STYLE, OR DESCRIBE ONE",
    "studio.ai.styleLabel": "Song style",
    "studio.ai.stylePlaceholder":
      "e.g. upbeat summer pop, acoustic guitar, catchy chorus",
    "studio.ai.lyrics": "Lyrics",
    // [Verse], [Chorus], [Bridge] are tags the generator reads: keep them.
    "studio.ai.lyricsPlaceholder":
      "Leave blank to let AI write the lyrics, or:\n\n[Verse 1]\nType your lyrics here...\n\n[Chorus]\nUse [Verse], [Chorus], [Bridge] tags to give it structure",
    "studio.ai.ownLyrics": "+ Write your own lyrics (otherwise AI writes them)",
    "studio.ai.use": "Use this song",
    "studio.ai.noStyle": "Describe the style of the song.",
    "studio.ai.styleTooLong":
      "Style description must be under {max} characters.",
    "studio.ai.lyricsTooLong": "Lyrics must be under {max} characters.",
    "studio.ai.genre.pop": "Pop",
    "studio.ai.genre.trap": "Trap",
    "studio.ai.genre.rnb": "R&B",
    "studio.ai.genre.indie": "Indie",
    "studio.ai.genre.kpop": "K-pop",
    "studio.ai.genre.edm": "EDM",
    "studio.ai.genre.lofi": "Lo-fi",
    "studio.ai.genre.country": "Country",
  },
  es: {
    "studio.title.none": "Haz un cover",
    "studio.title.one": "Haz cantar a {name}",
    "studio.title.many": "Hazlos cantar",
    "studio.section.voice": "Voz",
    "studio.section.whoSings": "Quién canta",
    "studio.section.count": "{n} de {max}",
    "studio.section.audio": "Audio",
    "studio.pickVoice": "Elige una voz",
    "studio.pickVoiceNote": "Más de 100,000 voces, o la tuya",
    "studio.addVoice": "Agregar una voz",
    "studio.whoSingsWhen": "Quién canta cuándo",
    "studio.sound": "Sonido",
    "studio.video": "Video",
    "studio.video.off": "Haz competir a tus voces en una Marble Run",
    "studio.video.on": "Marble Run · 1 moneda",
    "studio.video.add": "Agregar Marble Run · 1 moneda",
    "studio.coins.unlimited": "Monedas ilimitadas con Power",
    "studio.coins.one": "Te queda {count} moneda",
    "studio.coins.other": "Te quedan {count} monedas",
    "studio.done": "Listo",
    "studio.remove": "Quitar",
    "studio.cta.pickVoice": "Primero elige una voz",
    "studio.cta.addAudio": "Agrega audio",
    "studio.cta.create": "Crear cover",
    "studio.auth.video": "Regístrate para hacer un video",
    "studio.auth.audio": "Regístrate para usar tu audio",
    "studio.auth.save": "Guarda tu cover",
    "studio.upgrade.marbleRun":
      "Mejora a Creator para hacer videos de Marble Run",
    "studio.creatorReady": "Ya tienes Creator. Elige tu Marble Run.",
    "studio.maxVoices": "Puedes elegir un máximo de {max} voces.",
    "studio.alreadyIn": "{name} ya está en este cover.",

    "studio.voices.search": "Buscar voces",
    "studio.voices.clear": "Borrar búsqueda",
    "studio.voices.trending": "Tendencia",
    "studio.voices.recent": "Usadas recientemente",
    "studio.voices.mine": "Mis voces",
    "studio.voices.music": "Música",
    "studio.voices.cartoon": "Caricaturas",
    "studio.voices.gaming": "Videojuegos",
    "studio.voices.anime": "Anime",
    "studio.voices.publicFigure": "Figuras públicas",
    "studio.voices.oftenWith": "Suele ir con {name}",
    "studio.voices.pairedWith": "Suele combinarse con {name}",
    "studio.voices.add": "Agregar a {name}",
    "studio.voices.change": "Cambiar a {name}",
    "studio.voices.removeName": "Quitar a {name}",
    "studio.voices.upTo": "Hasta {max}",
    "studio.voices.makeDuet": "Haz un dueto",
    "studio.voices.uses": "{n} usos",
    "studio.voices.noMatch": "Ninguna voz coincide con tu búsqueda.",
    "studio.voices.noMine": "Todavía no tienes voces entrenadas.",
    "studio.voices.noPairs":
      "Esta semana aún no hay duetos con esta voz. Prueba Tendencia.",
    "studio.empty": "Aún no hay nada aquí.",
    "studio.change": "Cambiar",

    "studio.who.auto": "Automático",
    "studio.who.manual": "Elegir yo",
    "studio.who.chose.one": "Tú eliges · {n} parte",
    "studio.who.chose.other": "Tú eliges · {n} partes",
    "studio.who.autoExplain":
      "Las voces se turnan cada vez que cambia quien canta.",
    "studio.who.autoCanChoose":
      "¿Quieres decidir? Con Elegir yo escoges quién canta cada parte.",
    "studio.who.autoNeedsFile":
      "Para elegir tú, necesitas un audio subido, una grabación o una canción de la biblioteca.",
    "studio.who.loading": "Cargando la canción…",
    "studio.who.failed":
      "No pudimos reproducir esta canción aquí, así que Jammable decidirá.",
    "studio.who.pause": "Pausar",
    "studio.who.playSong": "Reproducir la canción",
    "studio.who.partLabel": "{name}, de {start} a {end}",
    "studio.who.moveSwap": "Mover dónde cambian las voces",
    "studio.who.part": "Parte {n}",
    "studio.who.play": "Reproducir",
    "studio.who.split": "Dividir",
    "studio.who.takeOver": "¿Quién se queda con esta parte?",
    "studio.who.before": "La parte anterior",
    "studio.who.after": "La parte siguiente",
    "studio.who.sungBy": "La canta",
    "studio.who.hint":
      "Toca una parte para escucharla y elegir quién la canta. Arrastra los controles blancos para mover dónde cambian las voces.",
    "studio.who.tooShort": "Cada parte necesita al menos {secs} segundos.",

    "studio.song.upload": "Subir",
    "studio.song.library": "Biblioteca",
    "studio.song.tts": "Escribir texto",
    "studio.song.generate": "Canción IA",
    "studio.song.mic": "Grabar",
    "studio.song.sources": "De dónde sale la canción",
    "studio.song.rights": "Sube solo audio que tengas derecho a usar.",
    "studio.song.search": "Buscar canciones",
    "studio.song.searchUploads": "Busca en tus audios subidos",
    "studio.song.searchLibrary": "Busca en la biblioteca de canciones",
    "studio.song.popular": "Populares",
    "studio.song.yourUploads": "Tus audios",
    "studio.song.noMatch": "Ninguna canción coincide con tu búsqueda.",
    "studio.song.noUploads": "Todavía no has subido nada.",
    "studio.song.picked": "Elegida",
    "studio.source.generate": "Generada con IA",
    "studio.source.upload": "Subida",
    "studio.source.library": "De la biblioteca",
    "studio.source.mic": "Grabada",
    "studio.source.tts": "Texto a voz",

    "studio.tts.what": "¿Qué deberían decir?",
    "studio.tts.placeholder": "Escribe lo que deberían decir...",
    "studio.tts.baseVoice": "VOZ BASE",
    "studio.tts.accent": "ACENTO",
    "studio.tts.delivery": "TONO",
    "studio.tts.use": "Usar este texto",
    "studio.tts.empty": "Escribe algo de texto.",
    "studio.tts.tooLong": "El texto supera el límite de {max} caracteres.",
    "studio.tts.gender.female": "Femenina",
    "studio.tts.gender.male": "Masculina",
    "studio.tts.accent.US": "Estadounidense",
    "studio.tts.accent.GB": "Británico",
    "studio.tts.accent.FR": "Francés",
    "studio.tts.accent.DE": "Alemán",
    "studio.tts.accent.ES": "Español",
    "studio.tts.accent.IT": "Italiano",
    "studio.tts.accent.KR": "Coreano",
    "studio.tts.accent.AU": "Australiano",
    "studio.tts.accent.JP": "Japonés",
    "studio.tts.expr.default": "Normal",
    "studio.tts.expr.whispered": "Susurrando",
    "studio.tts.expr.happy": "Feliz",
    "studio.tts.expr.sad": "Triste",
    "studio.tts.expr.angry": "Enojado",
    "studio.tts.expr.shouting": "Gritando",
    "studio.tts.expr.terrified": "Aterrado",

    "studio.ai.style": "ELIGE UN ESTILO O DESCRIBE UNO",
    "studio.ai.styleLabel": "Estilo de la canción",
    "studio.ai.stylePlaceholder":
      "p. ej. pop veraniego y alegre, guitarra acústica, coro pegadizo",
    "studio.ai.lyrics": "Letra",
    "studio.ai.lyricsPlaceholder":
      "Déjalo en blanco para que la IA escriba la letra, o:\n\n[Verse 1]\nEscribe tu letra aquí...\n\n[Chorus]\nUsa las etiquetas [Verse], [Chorus] y [Bridge] para darle estructura",
    "studio.ai.ownLyrics":
      "+ Escribe tu propia letra (si no, la escribe la IA)",
    "studio.ai.use": "Usar esta canción",
    "studio.ai.noStyle": "Describe el estilo de la canción.",
    "studio.ai.styleTooLong":
      "La descripción del estilo debe tener menos de {max} caracteres.",
    "studio.ai.lyricsTooLong": "La letra debe tener menos de {max} caracteres.",
    "studio.ai.genre.pop": "Pop",
    "studio.ai.genre.trap": "Trap",
    "studio.ai.genre.rnb": "R&B",
    "studio.ai.genre.indie": "Indie",
    "studio.ai.genre.kpop": "K-pop",
    "studio.ai.genre.edm": "EDM",
    "studio.ai.genre.lofi": "Lo-fi",
    "studio.ai.genre.country": "Country",
  },
  pt: {
    "studio.title.none": "Faça um cover",
    "studio.title.one": "Faça {name} cantar",
    "studio.title.many": "Faça eles cantarem",
    "studio.section.voice": "Voz",
    "studio.section.whoSings": "Quem canta",
    "studio.section.count": "{n} de {max}",
    "studio.section.audio": "Áudio",
    "studio.pickVoice": "Escolha uma voz",
    "studio.pickVoiceNote": "Mais de 100.000 vozes, ou a sua",
    "studio.addVoice": "Adicionar uma voz",
    "studio.whoSingsWhen": "Quem canta quando",
    "studio.sound": "Som",
    "studio.video": "Vídeo",
    "studio.video.off": "Coloque suas vozes para correr numa Marble Run",
    "studio.video.on": "Marble Run · 1 moeda",
    "studio.video.add": "Adicionar Marble Run · 1 moeda",
    "studio.coins.unlimited": "Moedas ilimitadas no Power",
    "studio.coins.one": "Resta {count} moeda",
    "studio.coins.other": "Restam {count} moedas",
    "studio.done": "Pronto",
    "studio.remove": "Remover",
    "studio.cta.pickVoice": "Escolha uma voz primeiro",
    "studio.cta.addAudio": "Adicione um áudio",
    "studio.cta.create": "Criar cover",
    "studio.auth.video": "Cadastre-se para fazer um vídeo",
    "studio.auth.audio": "Cadastre-se para usar seu áudio",
    "studio.auth.save": "Salve seu cover",
    "studio.upgrade.marbleRun":
      "Faça upgrade para o Creator para criar vídeos de Marble Run",
    "studio.creatorReady": "Você está no Creator. Escolha sua Marble Run.",
    "studio.maxVoices": "Você pode escolher no máximo {max} vozes.",
    "studio.alreadyIn": "{name} já está neste cover.",

    "studio.voices.search": "Buscar vozes",
    "studio.voices.clear": "Limpar busca",
    "studio.voices.trending": "Em alta",
    "studio.voices.recent": "Usadas recentemente",
    "studio.voices.mine": "Minhas vozes",
    "studio.voices.music": "Música",
    "studio.voices.cartoon": "Desenhos",
    "studio.voices.gaming": "Games",
    "studio.voices.anime": "Anime",
    "studio.voices.publicFigure": "Personalidades",
    "studio.voices.oftenWith": "Combina com {name}",
    "studio.voices.pairedWith": "Muito usada com {name}",
    "studio.voices.add": "Adicionar {name}",
    "studio.voices.change": "Trocar {name}",
    "studio.voices.removeName": "Remover {name}",
    "studio.voices.upTo": "Até {max}",
    "studio.voices.makeDuet": "Faça um dueto",
    "studio.voices.uses": "{n} usos",
    "studio.voices.noMatch": "Nenhuma voz corresponde à sua busca.",
    "studio.voices.noMine": "Você ainda não tem vozes treinadas.",
    "studio.voices.noPairs":
      "Ainda não há duetos com essa voz nesta semana. Tente Em alta.",
    "studio.empty": "Nada por aqui ainda.",
    "studio.change": "Trocar",

    "studio.who.auto": "Automático",
    "studio.who.manual": "Eu escolho",
    "studio.who.chose.one": "Você escolheu · {n} parte",
    "studio.who.chose.other": "Você escolheu · {n} partes",
    "studio.who.autoExplain":
      "As vozes se revezam sempre que muda quem está cantando.",
    "studio.who.autoCanChoose":
      "Quer decidir? Com Eu escolho você define quem canta cada parte.",
    "studio.who.autoNeedsFile":
      "Para escolher você mesmo, use um áudio enviado, uma gravação ou uma música da biblioteca.",
    "studio.who.loading": "Carregando a música…",
    "studio.who.failed":
      "Não conseguimos tocar essa música aqui, então o Jammable vai decidir.",
    "studio.who.pause": "Pausar",
    "studio.who.playSong": "Tocar a música",
    "studio.who.partLabel": "{name}, de {start} a {end}",
    "studio.who.moveSwap": "Mover onde as vozes trocam",
    "studio.who.part": "Parte {n}",
    "studio.who.play": "Tocar",
    "studio.who.split": "Dividir",
    "studio.who.takeOver": "Quem fica com esta parte?",
    "studio.who.before": "A parte anterior",
    "studio.who.after": "A parte seguinte",
    "studio.who.sungBy": "Cantada por",
    "studio.who.hint":
      "Toque numa parte para ouvi-la e escolher quem canta. Arraste as alças brancas para mover onde as vozes trocam.",
    "studio.who.tooShort": "Cada parte precisa de pelo menos {secs} segundos.",

    "studio.song.upload": "Enviar",
    "studio.song.library": "Biblioteca",
    "studio.song.tts": "Digitar texto",
    "studio.song.generate": "Música IA",
    "studio.song.mic": "Gravar",
    "studio.song.sources": "De onde vem a música",
    "studio.song.rights": "Envie só áudios que você tem direito de usar.",
    "studio.song.search": "Buscar músicas",
    "studio.song.searchUploads": "Busque nos seus envios",
    "studio.song.searchLibrary": "Busque na biblioteca de músicas",
    "studio.song.popular": "Populares",
    "studio.song.yourUploads": "Seus envios",
    "studio.song.noMatch": "Nenhuma música corresponde à sua busca.",
    "studio.song.noUploads": "Você ainda não enviou nada.",
    "studio.song.picked": "Escolhida",
    "studio.source.generate": "Gerada por IA",
    "studio.source.upload": "Enviada",
    "studio.source.library": "Da biblioteca",
    "studio.source.mic": "Gravada",
    "studio.source.tts": "Texto para fala",

    "studio.tts.what": "O que eles devem dizer?",
    "studio.tts.placeholder": "Digite o que eles devem dizer...",
    "studio.tts.baseVoice": "VOZ BASE",
    "studio.tts.accent": "SOTAQUE",
    "studio.tts.delivery": "TOM",
    "studio.tts.use": "Usar este texto",
    "studio.tts.empty": "Digite algum texto.",
    "studio.tts.tooLong": "O texto passa do limite de {max} caracteres.",
    "studio.tts.gender.female": "Feminina",
    "studio.tts.gender.male": "Masculina",
    "studio.tts.accent.US": "Americano",
    "studio.tts.accent.GB": "Britânico",
    "studio.tts.accent.FR": "Francês",
    "studio.tts.accent.DE": "Alemão",
    "studio.tts.accent.ES": "Espanhol",
    "studio.tts.accent.IT": "Italiano",
    "studio.tts.accent.KR": "Coreano",
    "studio.tts.accent.AU": "Australiano",
    "studio.tts.accent.JP": "Japonês",
    "studio.tts.expr.default": "Normal",
    "studio.tts.expr.whispered": "Sussurrando",
    "studio.tts.expr.happy": "Feliz",
    "studio.tts.expr.sad": "Triste",
    "studio.tts.expr.angry": "Bravo",
    "studio.tts.expr.shouting": "Gritando",
    "studio.tts.expr.terrified": "Apavorado",

    "studio.ai.style": "ESCOLHA UM ESTILO OU DESCREVA UM",
    "studio.ai.styleLabel": "Estilo da música",
    "studio.ai.stylePlaceholder":
      "ex.: pop de verão animado, violão, refrão chiclete",
    "studio.ai.lyrics": "Letra",
    "studio.ai.lyricsPlaceholder":
      "Deixe em branco para a IA escrever a letra, ou:\n\n[Verse 1]\nDigite sua letra aqui...\n\n[Chorus]\nUse as tags [Verse], [Chorus] e [Bridge] para dar estrutura",
    "studio.ai.ownLyrics": "+ Escreva sua própria letra (senão a IA escreve)",
    "studio.ai.use": "Usar esta música",
    "studio.ai.noStyle": "Descreva o estilo da música.",
    "studio.ai.styleTooLong":
      "A descrição do estilo deve ter menos de {max} caracteres.",
    "studio.ai.lyricsTooLong": "A letra deve ter menos de {max} caracteres.",
    "studio.ai.genre.pop": "Pop",
    "studio.ai.genre.trap": "Trap",
    "studio.ai.genre.rnb": "R&B",
    "studio.ai.genre.indie": "Indie",
    "studio.ai.genre.kpop": "K-pop",
    "studio.ai.genre.edm": "EDM",
    "studio.ai.genre.lofi": "Lo-fi",
    "studio.ai.genre.country": "Country",
  },
};
